export default __webpack_public_path__ + "static/media/gi.da0467f2.svg";